import React from "react";
import HomePage from "./pages/homepage"; // Adjust the import path as necessary

const App = () => {
  return (
    <div>
      <HomePage /> {/* Render HomePage here */}
    </div>
  );
};

export default App;
